// TODO use enum + iso66x npm package

import omit from 'lodash/omit';
import { LanguageAttributes } from '../gamification-api-client/types/language';

export enum Language {
  en = 'en',
  fr = 'fr',
  es = 'es',
  nl = 'nl',
  pt = 'pt',
  de = 'de',
  it = 'it',
  el = 'el',
}

export const SYSTEM_LANGUAGES: Record<Language, LanguageAttributes> = {
  fr: { name: 'French', isoCode: 'fr' },
  en: { name: 'English', isoCode: 'en' },
  de: { name: 'German', isoCode: 'de' },
  es: { name: 'Spanish', isoCode: 'es' },
  nl: { name: 'Dutch', isoCode: 'nl' },
  it: { name: 'Italian', isoCode: 'it' },
  pt: { name: 'Portuguese', isoCode: 'pt' },
  el: { name: 'Greek', isoCode: 'el' },
};

export const SYSTEM_ISO_CODES = Object.values(SYSTEM_LANGUAGES).map(language => language.isoCode);

export const BACKOFFICE_LANGUAGES = omit(SYSTEM_LANGUAGES, ['pt', 'el']);

export const DEFAULT_LANGUAGE = Language.en;

export const LanguageLocales: Record<Language, string> = {
  en: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
  nl: 'nl-NL',
  pt: 'pt-PT',
  de: 'de-DE',
  it: 'it-IT',
  el: 'el-GR',
};
